// theme.js

import { createGlobalStyle } from 'styled-components';

export const lightTheme = {
  body: '#ffffff',
  // text: '#000000',
  primary: '#007bff',
  borderRadius: '4px',
  padding: '10px 20px',
  marginLeft: '10px',
  cursor: 'pointer',
};

export const darkTheme = {
  body: '#000000',
  // text: '#000000', // Changed to white for better visibility
  primary: 'black',
  borderRadius: '4px',
  padding: '10px 20px',
  marginLeft: '10px',
  cursor: 'pointer',
};

export const GlobalStyles = createGlobalStyle`
  body {
    background-color: ${props => props.theme.body};
    color: ${props => props.theme.text};
    transition: background-color 0.3s ease;
  }
`;
